export default {"src":"/_next/static/media/lifecycles.32083129.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};